/**************************************************
 * Nombre:       Seccion_Calendario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import Calendario_Calendario from "./Componentes/Calendario_Calendario";
import Calendario_Anuncio from "./Componentes/Calendario_Anuncio";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useParams} from "react-router-dom";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";


const Seccion_Calendario = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [evento, setEvento] = useState({})


    useEffect(() => {

        setEvento({})
        if (parms && parms.id){
            obtenerDoc('eventos', parms.id).then((dox) =>{
                if (dox.res){
                    setEvento(dox.data)
                }
            })
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={4}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Calendario_Anuncio eventoViene={evento}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -2 : 0}}>
                    <Calendario_Calendario/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Calendario

